<template>
  <div class="main-wrapper">
    <p>
      Если у вас есть токен квалифицированной ЭЦП, то вы можете подписать вашу
      анкету прямо сейчас. При этом в соответствии с Законом №63-ФЗ от
      06.04.2011 ваша заявка будет считаться юридически подписанной.
    </p>
    <button class="ecp-button" @click="getDataToSign()">
      Вставьте токен с ЭЦП и нажмите кнопку
    </button>
    <div v-show="isClicked">
      <p>Сертификат:</p>
      <div>
        <select size="8" id="CertListBox" class="ecp-select"></select>
      </div>
      <br />
      <button class="ecp-button" @click="createSignature()">
        Подписать и отправить
      </button>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  name: "NeedECP",
  props: {
    pageInfo: {},
    pageName: String,
    url: String,
  },
  data: () => ({
    sendData: {},
    dataServer: "",
    isClicked: false,
  }),
  methods: {
    validation() {
      this.$emit("enableButtons", true, "");
      this.$emit("changePageSendData", this.sendData, false);
    },
    async getDataToSign() {
      try {
        var response = await Axios.get(
          this.url + "get_questionnaire_xml?id=" + this.pageInfo.ID
        );
        this.dataServer = response.data;
      } catch (error) {
        this.$alert("Не удалось получить данные с сервера");
        console.log(error);
      }
      this.isClicked = true;
      window.FillCertList_Async("CertListBox");
    },
    getInnFromCertificate(certificate) {
      var inn = certificate.substr(certificate.indexOf("ИНН=") + 4, 12);
      inn[11] >= "0" && inn[11] <= "9"
        ? console.log("")
        : (inn = inn.substr(0, 10));
      inn[0] == 0 && inn[1] == 0 && inn.length == 12
        ? (inn = inn.substr(2, 11))
        : inn;
      return inn;
    },
    async checkINN() {
      var cerINN;
      var selectedIndex = document.getElementById("CertListBox").options
        .selectedIndex;
      var certInfo = await window.global_selectbox_container[selectedIndex]
        .SubjectName;
      var indexPlus = 4;
      var innIndex = certInfo.indexOf("INN=");
      if (innIndex < 0) innIndex = certInfo.indexOf("ИНН=");
      if (innIndex < 0) {
        innIndex = certInfo.indexOf("OU=");
        indexPlus = 3;
      }
      if (innIndex > 0) {
        var inn = certInfo.substring(innIndex + indexPlus).substring(0, 12);
        var resultInn = "";
        for (var i = 0; i < inn.length; i++) {
          var ch = inn.charAt(i);
          if (ch >= "0" && ch <= "9") resultInn += ch;
        }
        if (resultInn.startsWith("00")) resultInn = resultInn.substring(2);
        cerINN = resultInn;
      }
      return cerINN == this.pageInfo.INN;
    },
    async createSignature() {
      try {
        var dataInBase64 = this.b64EncodeUnicode(this.dataServer);
        var url = this.url;
        var id = this.pageInfo.ID;
        if (await this.checkINN()) {
          this.$emit("isLoading", true);
          window.SignCreate_ContainerStore(dataInBase64).then(
            (signedMessage) => {
              window.Verify(signedMessage, dataInBase64).then(
                () => {
                  var xhr = new XMLHttpRequest();
                  xhr.open("POST", url + "postds/" + id, true);
                  xhr.setRequestHeader("Content-type", "text/plain");
                  xhr.onreadystatechange = () => {
                    if (xhr.readyState == XMLHttpRequest.DONE) {
                      if (xhr.status == 200) {
                        this.$emit("isLoading", false);
                        this.$alert("Документ успешно подписан");
                        this.$emit("nextStep");
                      } else {
                        this.$emit("isLoading", false);
                        this.$alert("Ошибка: " + xhr.responseText);
                        console.error(xhr.responseText);
                      }
                    }
                  };
                  xhr.send(signedMessage);
                },
                (err) => {
                  this.$emit("isLoading", false);
                  this.$alert("Ошибка верификации подписи ЭЦП");
                  console.log(err);
                }
              );
            },
            (err) => {
              this.$emit("isLoading", false);
              this.$alert("Ошибка при создании подписи ЭЦП");
              console.log(err);
            }
          );
        } else {
          this.$alert("Вы не можете использовать данную подпись");
        }
      } catch (error) {
        console.log(error);
      }
    },
    b64EncodeUnicode(str) {
      return btoa(
        encodeURIComponent(str).replace(
          /%([0-9A-F]{2})/g,
          function toSolidBytes(match, p1) {
            return String.fromCharCode("0x" + p1);
          }
        )
      );
    },
  },
  created() {
    this.sendData.ID = this.pageInfo.ID;
    this.sendData.INN = this.pageInfo.INN;
    this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
    this.validation();
  },
};
</script>

<style scoped>
.ecp-button {
  background-color: #06569b;
  border: 1px solid #0059a7;
  border-radius: 0px;
  padding: 5px 10px;
  color: white;
}
.ecp-button:hover {
  background-color: #1260a5;
}
.ecp-button:active,
.ecp-button:focus {
  outline: none;
}
.ecp-select {
  width: 100%;
  resize: none;
  border: 0;
}
.ecp-select:focus,
.ecp-select:active {
  outline: none;
}
</style>
